import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Row hover background that persists while a child popover (data-state=open) is open. */
export const INTERACTIVE_ROW_HOVER_BG =
  'hover:bg-gray-50 has-[[data-state=open]]:bg-gray-50 dark:hover:bg-gray-800 dark:has-[[data-state=open]]:bg-gray-800'

/** Desktop-only variant with md: responsive prefix. */
export const INTERACTIVE_ROW_HOVER_BG_MD =
  'md:hover:bg-gray-50 md:has-[[data-state=open]]:bg-gray-50 md:dark:hover:bg-gray-800 md:dark:has-[[data-state=open]]:bg-gray-800'
